<script>
	import { toastMessage } from "src/store/store";
	import { Toast, ToastBody } from "@sveltestrap/sveltestrap";

	export let message;
	export let type = false;
	export let danger = false;

	$: isOpen = message ? true : false;

	function handleOnClose() {
		message = "";
		toastMessage.set({ message: "", type: "" });
	}
</script>

<Toast
	class="getgo-toast"
	{isOpen}
	autohide={true}
	delay={3000}
	on:close={handleOnClose}
>
	<ToastBody>
		<div class="d-flex align-items-center">
			{#if type === "danger"}
				<img
					src="/assets/icon-danger.svg"
					alt="danger-icon"
					class="me-2"
				/>
			{:else}
				<img
					src="/assets/icon-success.svg"
					alt="success-icon"
					class="me-2"
				/>
			{/if}
			{message}
		</div>
	</ToastBody>
</Toast>

<style>
	:global(.getgo-toast.toast) {
		position: fixed;
		width: auto;
		background-color: black;
		color: white;
		border-radius: 8px;
		bottom: 80px;
		min-width: 350px;
		left: 50%;
		transform: translateX(-50%);
	}
</style>
